module.exports = __webpack_public_path__ + "img/project_model_bg.2d4a9323.jpg";